// extracted by mini-css-extract-plugin
export default {"errorMessage":"ResetPasswordForm_errorMessage__VOehk","resetButton":"ResetPasswordForm_resetButton__gCGup"};